import { CSSProperties } from "react";

const WebsiteUnderMaintenance = () => {
  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <div style={styles.iconContainer}>
          <span style={styles.icon}>🔧</span>
        </div>
        
        <h1 style={styles.heading}>Under Maintenance</h1>
        
        <p style={styles.message}>
          We're currently performing scheduled maintenance to improve your experience.
        </p>
        
        <p style={styles.subMessage}>
          Our website will be back online shortly. Thank you for your patience!
        </p>
        
        <div style={styles.loader}>
          <div style={styles.dot}></div>
          <div style={styles.dot}></div>
          <div style={styles.dot}></div>
        </div>
        
        <p style={styles.contact}>
          If you have any urgent questions, please contact us at: 
          <a href="mailto:hemantjimin@gmail.com" style={styles.link}>
            
hemantjimin@gmail.com          </a>
        </p>
      </div>
    </div>
  );
};

const styles: { [key: string]: CSSProperties } = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    padding: "20px",
  } as CSSProperties,
  content: {
    textAlign: "center",
    backgroundColor: "white",
    padding: "60px 40px",
    borderRadius: "15px",
    boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
    maxWidth: "600px",
    width: "100%",
  } as CSSProperties,
  iconContainer: {
    marginBottom: "30px",
  } as CSSProperties,
  icon: {
    fontSize: "80px",
    display: "block",
    animation: "spin 2s linear infinite",
  } as CSSProperties,
  heading: {
    fontSize: "48px",
    color: "#333",
    marginBottom: "20px",
    fontWeight: "bold",
  } as CSSProperties,
  message: {
    fontSize: "18px",
    color: "#666",
    marginBottom: "15px",
    lineHeight: "1.6",
  } as CSSProperties,
  subMessage: {
    fontSize: "16px",
    color: "#888",
    marginBottom: "40px",
    lineHeight: "1.5",
  } as CSSProperties,
  loader: {
    display: "flex",
    justifyContent: "center",
    gap: "8px",
    marginBottom: "40px",
  } as CSSProperties,
  dot: {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    backgroundColor: "#667eea",
    animation: "bounce 1.4s infinite ease-in-out both",
  } as CSSProperties,
  contact: {
    fontSize: "14px",
    color: "#666",
    marginTop: "30px",
    paddingTop: "30px",
    borderTop: "1px solid #eee",
  } as CSSProperties,
  link: {
    color: "#667eea",
    textDecoration: "none",
    fontWeight: "bold",
    marginLeft: "8px",
  } as CSSProperties,
};

// Add keyframe animations
const styleSheet = document.createElement("style");
styleSheet.textContent = `
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
  
  @keyframes bounce {
    0%, 80%, 100% {
      transform: scale(1);
      opacity: 0.7;
    }
    40% {
      transform: scale(1.3);
      opacity: 1;
    }
  }
`;
document.head.appendChild(styleSheet);

export default WebsiteUnderMaintenance;
